export default {
  'storyHero.label': 'Brand Story',
  'storyHero.title': '讓數據',
  'storyHero.titleAccent': '回歸核心',
  'storyHero.description': '在幾何學中，軸心是旋轉的基礎，是力量的來源。在數字世界中，AX Axis 致力於成為每個人、每個家庭、每家企業的「數字旋轉軸心」。',
  'storyHero.bottomLine': 'DATA RETURNS TO THE AXIS',

  'storyContent.ch1.label': '序章',
  'storyContent.ch1.title': '失控的數字雲端',
  'storyContent.ch1.body.0': '在二十一世紀的第三個十年，人類生活在一個弔詭的時代。',
  'storyContent.ch1.body.1': '我們所有的記憶——照片、文檔、通訊紀錄、甚至是深夜的突發奇想——都被裝載進無形的「雲端」。這些數據漂浮在由科技巨頭掌控的服務器中。我們在享受便利的同時，卻也交出了數據的物理掌控權。數據洩露、算法窺視、服務中斷，讓這朵「雲」變得沈重且不可捉摸。',
  'storyContent.ch1.body.2': '這是一個數據主權逐漸失控的時代，而這正是 AX Axis 故事的起點。',

  'storyContent.ch2.label': '轉折',
  'storyContent.ch2.title': '軸心的誕生',
  'storyContent.ch2.body.0': '「為什麼我們最珍貴的數字資產，不能像實體存摺一樣，安全地鎖在自己的抽屜裡？」',
  'storyContent.ch2.body.1': '這個問題，讓在香港深耕多年的系統架構師與在大灣區擁有極致工藝追求的硬件工程師走到了一起。香港的國際視野賦予了我們對數據安全標準的偏執，而內地的強大供應鏈則讓這種偏執得以具現化。',
  'storyContent.ch2.body.2': '我們決定打破傳統 NAS（網絡附屬存儲）繁瑣、笨重的刻板印象。',
  'storyContent.ch2.body.3': '我們將品牌命名為 Axis（軸心）。在幾何學中，軸心是旋轉的基礎，是力量的來源。在數字世界中，AX Axis 致力於成為每個人、每個家庭、每家企業的「數字旋轉軸心」。',

  'storyContent.ch3.label': '碰撞',
  'storyContent.ch3.title': '技術與美學的碰撞',
  'storyContent.ch3.body.0': '我們不滿足於僅僅做一個存儲器。',
  'storyContent.ch3.body.1': 'Axis OS 的靈魂：我們花費數千個日夜，從底層內核開始重寫，只為了解決一個痛點：如何在保證絕對私密的前提下，實現流暢如本地磁盤的遠程訪問。',
  'storyContent.ch3.body.2': '特斯拉式的工業哲學：我們拒絕廉價的塑料感。每一台 Axis Hub 都要經歷數十道陽極氧化工序，採用一體成型的鋁合金機身。我們相信，守護數據的設備本身，就應該像一件藝術品。',

  'storyContent.ch4.label': '願景',
  'storyContent.ch4.title': '讓數據回歸核心',
  'storyContent.ch4.body.0': '今天，AX Axis 不僅僅是一家香港研發、全球交付的科技公司，我們更是一場關於「數字自主」的運動。',
  'storyContent.ch4.body.1': '當你打開手機，瞬時加載出家中硬盤裡的 4K 影片；當你身在紐約，卻能毫無延遲地讀取香港辦公室的設計草稿；當你不再收到精準得令人恐懼的廣告推送，因為你的行為數據從未離開過你的書房……',
  'storyContent.ch4.body.2': '那一刻，你會明白 AX Axis 的意義。',
  'storyContent.ch4.body.3': '讓數據，回歸核心。讓主權，回歸於你。',

  'storyValues.label': 'Core Values',
  'storyValues.title': '品牌價值觀',
  'storyValues.subtitle': '四大基石，構建 AX Axis 的數字自主信念體系',
  'storyValues.value1.title': '物理安全',
  'storyValues.value1.en': 'Physicality',
  'storyValues.value1.desc': '看得見、摸得著的數據，才是真正安全的數據。',
  'storyValues.value2.title': '極致速度',
  'storyValues.value2.en': 'Performance',
  'storyValues.value2.desc': '技術不應成為創造力的絆腳石。',
  'storyValues.value3.title': '隱私主權',
  'storyValues.value3.en': 'Sovereignty',
  'storyValues.value3.desc': '拒絕數據採集，守護數字世界的最後一公里。',
  'storyValues.value4.title': '簡約美學',
  'storyValues.value4.en': 'Minimalism',
  'storyValues.value4.desc': '繁雜交給底層系統，極簡留給用戶體驗。',
};